import type { IconNode } from '../types';

/**
 * @name cow-head
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTcuOCAxNS4xYTEwIDEwIDAgMCAwIC45LTcuMWguM2MxLjcgMCAzLTEuMyAzLTNWM2gtM2MtMS4zIDAtMi40LjgtMi44IDEuOWExMCAxMCAwIDAgMC04LjQgMEM3LjQgMy44IDYuMyAzIDUgM0gydjJjMCAxLjcgMS4zIDMgMyAzaC4zYTEwIDEwIDAgMCAwIC45IDcuMSIgLz4KICA8cGF0aCBkPSJNOSA5LjV2LjUiIC8+CiAgPHBhdGggZD0iTTE1IDkuNXYuNSIgLz4KICA8cGF0aCBkPSJNMTUgMjJhNCA0IDAgMSAwLTMtNi42QTQgNCAwIDEgMCA5IDIyWiIgLz4KICA8cGF0aCBkPSJNOSAxOGguMDEiIC8+CiAgPHBhdGggZD0iTTE1IDE4aC4wMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/cow-head
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const cowHead: IconNode = [
  [
    'path',
    {
      d: 'M17.8 15.1a10 10 0 0 0 .9-7.1h.3c1.7 0 3-1.3 3-3V3h-3c-1.3 0-2.4.8-2.8 1.9a10 10 0 0 0-8.4 0C7.4 3.8 6.3 3 5 3H2v2c0 1.7 1.3 3 3 3h.3a10 10 0 0 0 .9 7.1',
      key: '1mfk94',
    },
  ],
  ['path', { d: 'M9 9.5v.5', key: '19rpjw' }],
  ['path', { d: 'M15 9.5v.5', key: '1bq2m4' }],
  ['path', { d: 'M15 22a4 4 0 1 0-3-6.6A4 4 0 1 0 9 22Z', key: '17jix9' }],
  ['path', { d: 'M9 18h.01', key: '2qx7s0' }],
  ['path', { d: 'M15 18h.01', key: 'pd7i4d' }],
];

export default cowHead;
